import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';
import { AttentionModalComponent } from '@shared/components';
import { DropdownItem } from '@shared/models';
import { toTitleCase } from '@shared/utils';

const ALL_TARGET_STATES: DropdownItem[] = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Prospect', value: 'PROSPECT' },
  { label: 'Inactive', value: 'INACTIVE' },
  { label: 'Suspended', value: 'SUSPENDED' },
];

@Component({
  selector: 'app-update-business-account-state-modal',
  templateUrl: './update-business-account-state-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, NgSelectModule, AttentionModalComponent, RktButtonDirective],
})
export class UpdateBusinessAccountStateModalComponent {
  activeModal = inject(ActiveModal);

  name = '';

  currentState = '';

  parentId?: string;

  items: DropdownItem[] = [];

  selectedState?: string;

  modalInitData({ name, currentState, parentId }: { name: string; currentState: string; parentId?: string }): void {
    this.name = name;
    this.currentState = currentState;
    this.parentId = parentId;

    if (currentState === 'SUSPENDED') {
      // Leaving SUSPENDED is only supported via /unsuspend, which restores the account to ACTIVE.
      this.items = [{ label: 'Active', value: 'ACTIVE' }];
    } else {
      this.items = ALL_TARGET_STATES.filter((item) => item.value !== currentState);
    }
  }

  get warningText(): string {
    if (!this.selectedState) {
      return `Select a new state for Business Account "${this.name}".`;
    }

    let text = `You are about to change the state of Business Account "${this.name}" to ${toTitleCase(this.selectedState)}.`;

    if (this.selectedState === 'SUSPENDED' && !this.parentId) {
      text += ' Suspending this Parent Account will also suspend all related Child Business Accounts.';
    }

    if (this.currentState === 'SUSPENDED') {
      text += ' The account will be unsuspended and restored to Active.';
    }

    return text;
  }
}
